import { translations } from "./content/translations";
import { urls } from "./constants";

//let lang = localStorage.getItem("user_language");
let lang = "en";

export const priceForm = () => {
    const priceForm = document.querySelector("#priceForm");

    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
    const nameOf = (item) => (item.ff_name || item.display_name || "").trim();
    const bySeqThenName = (a, b) => {
        const sa = Number.isFinite(a.ff_sequence) ? a.ff_sequence : Number.POSITIVE_INFINITY;
        const sb = Number.isFinite(b.ff_sequence) ? b.ff_sequence : Number.POSITIVE_INFINITY;
        if (sa !== sb) return sa - sb;
        return collator.compare(nameOf(a), nameOf(b));
    };
    const linkifyName = (item) => {
        const label = nameOf(item);
        const url = item.ff_url;
        if (!url) return label;
        const external = /^https?:\/\//i.test(url);
        return `<a href="${url}"${external ? ' target="_blank" rel="noopener"' : ""}>${label}</a>`;
    };

    fetch("/get-pricelist")
        .then((r) => {
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
        .then((priceList) => {
            // Build grouped arrays AND a category sequence map
            const { grouped, seqMap } = priceList.reduce(
                (acc, p) => {
                    // label: prefer explicit ff_category, else take name from [id, name] tuple
                    const cat = (
                        p.ff_category
                            ? p.ff_category
                            : (Array.isArray(p.ff_category_id) && p.ff_category_id.length > 1
                                ? String(p.ff_category_id[1])
                                : "—")
                        ) || "—";
                    (acc.grouped[cat] ||= []).push(p);

                    // sequence: prefer explicit ff_category_sequence, else default large number
                    const seq = Number.isFinite(p.ff_category_sequence) ? p.ff_category_sequence : 1e9;
                    acc.seqMap[cat] = Math.min(acc.seqMap[cat] ?? seq, seq);
                    return acc;
                },
                { grouped: {}, seqMap: {} }
            );

            // Order categories by category sequence, then by label
            const categoryNames = Object.keys(grouped).sort((a, b) => {
                const sa = seqMap[a] ?? 1e9;
                const sb = seqMap[b] ?? 1e9;
                if (sa !== sb) return sa - sb;
                return a.localeCompare(b);
            });

            // Sort products inside each category by ff_sequence, then name
            for (const cat of categoryNames) {
                if (Array.isArray(grouped[cat])) grouped[cat].sort(bySeqThenName);
            }

            const html = `
                <div class="container">
                <div class="row fw-semibold border-bottom pb-1">
                    <div class="col-12 col-md-3 text-center">${translations.products[lang]}</div>
                    <div class="col-12 col-md-7 text-center">${translations.description[lang]}</div>
                    <div class="col-6 col-md-1 text-center">${translations.unitWeigth[lang]}</div>
                    <div class="col-6 col-md-1 text-center">${translations.price[lang]}</div>
                </div>
                ${categoryNames
                    .map(
                        (cat) => `
                        <div class="mb-4 border-bottom">
                        <h2 class="text-start mt-3 price-list-title">${cat}</h2>
                        ${grouped[cat]
                            .map(
                                (item) => `
                                <div class="row align-items-center py-1">
                                    <div class="col-12 col-md-3 text-start">${linkifyName(item)}</div>
                                    <div class="col-12 col-md-7 text-start">${item.ff_description || item.description_sale || ""}</div>
                                    <div class="col-6 col-md-1 text-center">${item.ff_weight || ""}</div>
                                    <div class="col-6 col-md-1 text-center">$${Number(item.lst_price || 0).toFixed(2)}</div>
                                </div>
                                `
                            )
                            .join("")}
                        </div>`
                        )
                    .join("")}
                </div>
            `;

            priceForm.innerHTML = html;
        })
        .catch((err) => {
            console.error(`${translations.failedLoadPrices[lang]}:`, err);
            priceForm.innerHTML = `
                <div class="col-12">
                <div class="alert alert-danger">${translations.failedLoadPrices[lang]}</div>
                </div>
            `;
        });
};

